import React, { useState } from 'react'
import style from './portFolio.module.css'

const PortfolioPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tous')
  const [selectedProject, setSelectedProject] = useState(null)

  const categories = ['Tous', 'Immobilier', 'Agropastoral', 'Finance', 'Industrie', 'Partenariats']

  const projects = [
    {
      id: 1,
      title: "Complexe Immobilier Résidentiel",
      category: "Immobilier",
      client: "Promoteur privé",
      description: "Acquisition foncière stratégique et structuration complète pour la construction d'un complexe immobilier d'envergure.",
      fullDescription: "Mission d'assistance administrative complète incluant le mandat d'acquisition foncière en vue de la construction d'un complexe immobilier haut standing. Notre équipe a géré l'ensemble du processus d'acquisition, les négociations avec les propriétaires terriens, et la validation administrative du projet.",
      services: [
        "Mandat d'acquisition foncière",
        "Assistance administrative complète",
        "Négociation et due diligence",
        "Validation des titres fonciers"
      ],
      results: [
        "Acquisition réussie en 6 mois",
        "Économie de 15% sur le budget initial",
        "Tous les permis obtenus"
      ],
      image: "🏢",
      year: "2024",
      duration: "6 mois",
      featured: true
    },
    {
      id: 2,
      title: "Gestion de 52 Unités d'Habitation",
      category: "Immobilier",
      client: "Groupe immobilier",
      description: "Asset management et conseil en gestion pour l'estimation et le pilotage d'un projet de construction d'envergure.",
      fullDescription: "Mission d'asset management comprenant le conseil en gestion immobilière, l'estimation détaillée du projet de construction d'un complexe résidentiel de 52 unités d'habitation. Nous avons accompagné le client dans l'optimisation des coûts, la planification financière et la structuration de la gestion locative.",
      services: [
        "Asset management",
        "Estimation de projet",
        "Conseil en gestion immobilière",
        "Planification financière"
      ],
      results: [
        "ROI estimé à 12% annuel",
        "Optimisation budgétaire de 20%",
        "Plan de gestion sur 10 ans établi"
      ],
      image: "🏘️",
      year: "2023-2024",
      duration: "9 mois",
      featured: true
    },
    {
      id: 3,
      title: "Technopole Agropastoral",
      category: "Agropastoral",
      client: "Consortium agricole",
      description: "Conseil et structuration complète pour l'implantation d'un technopole agropastoral innovant.",
      fullDescription: "Projet stratégique d'implantation d'un technopole agropastoral intégrant les dernières technologies agricoles. Notre mission a consisté à structurer le projet, identifier les partenaires techniques, établir le modèle économique et accompagner le montage financier de cette infrastructure d'envergure régionale.",
      services: [
        "Étude de faisabilité",
        "Structuration du projet",
        "Recherche de partenaires",
        "Montage financier"
      ],
      results: [
        "Projet structuré en 12 mois",
        "5 partenaires techniques identifiés",
        "Financement de 2.5M€ sécurisé"
      ],
      image: "🌾",
      year: "2023",
      duration: "12 mois",
      featured: true
    },
    {
      id: 4,
      title: "Financement du Contenu Local",
      category: "Finance",
      client: "Institutions publiques",
      description: "Étude approfondie sur le financement structuré et intégré des secteurs prioritaires du contenu local.",
      fullDescription: "Étude stratégique portant sur le financement structuré et intégré des secteurs prioritaires du contenu local. Analyse des mécanismes de financement innovants, identification des secteurs prioritaires, et proposition d'un cadre réglementaire adapté pour maximiser l'impact économique local.",
      services: [
        "Étude de financement structuré",
        "Analyse sectorielle",
        "Recommandations stratégiques",
        "Cadre réglementaire"
      ],
      results: [
        "15 secteurs prioritaires identifiés",
        "Mécanismes de financement innovants",
        "Cadre adopté par les autorités"
      ],
      image: "💰",
      year: "2023",
      duration: "8 mois",
      featured: false
    },
    {
      id: 5,
      title: "Programme HIMO",
      category: "Industrie",
      client: "Organisme international",
      description: "Étude de cadrage pour le déploiement d'un programme à haute intensité de main-d'œuvre.",
      fullDescription: "Étude de cadrage complète pour le déploiement d'un programme à haute intensité de main-d'œuvre (HIMO). Analyse des besoins en emploi, identification des secteurs porteurs, structuration du programme de formation et accompagnement des bénéficiaires.",
      services: [
        "Étude de cadrage",
        "Analyse du marché de l'emploi",
        "Structuration du programme",
        "Plan de déploiement"
      ],
      results: [
        "500 emplois directs créés",
        "Programme déployé dans 3 régions",
        "Taux de satisfaction de 85%"
      ],
      image: "👷",
      year: "2022-2023",
      duration: "10 mois",
      featured: false
    },
    {
      id: 6,
      title: "Immeuble R+8 en Partenariat",
      category: "Partenariats",
      client: "Promoteur international",
      description: "Assistance technique complète dans le cadre d'un partenariat pour la construction d'un immeuble R+8.",
      fullDescription: "Mission d'assistance technique dans le cadre d'un partenariat stratégique pour la construction d'un immeuble de standing R+8. Notre rôle a consisté à faciliter le partenariat, assurer la coordination technique, et garantir la conformité du projet aux normes internationales.",
      services: [
        "Assistance technique",
        "Coordination partenariale",
        "Contrôle qualité",
        "Gestion administrative"
      ],
      results: [
        "Partenariat structuré en 4 mois",
        "Livraison dans les délais",
        "Conformité aux normes ISO"
      ],
      image: "🏗️",
      year: "2023",
      duration: "18 mois",
      featured: false
    },
    {
      id: 7,
      title: "Importation Produits Phytosanitaires",
      category: "Agropastoral",
      client: "Entreprise agricole (Sénégal)",
      description: "Étude de faisabilité pour l'importation de produits phytosanitaires à usage agricole au Sénégal.",
      fullDescription: "Étude de faisabilité complète en vue de l'importation de produits phytosanitaires à usage agricole au Sénégal. Analyse réglementaire, étude de marché, identification des fournisseurs et structuration du modèle d'affaires.",
      services: [
        "Étude de faisabilité",
        "Analyse réglementaire",
        "Étude de marché",
        "Identification de fournisseurs"
      ],
      results: [
        "Marché évalué à 5M€/an",
        "3 fournisseurs certifiés identifiés",
        "Autorisation d'importation obtenue"
      ],
      image: "🌱",
      year: "2023",
      duration: "5 mois",
      featured: false
    }
  ]

  const stats = [
    { number: "25+", label: "Projets Réalisés" },
    { number: "15+", label: "Clients Satisfaits" },
    { number: "98%", label: "Taux de Réussite" }
  ]

  const filteredProjects = selectedCategory === 'Tous' 
    ? projects 
    : projects.filter(project => project.category === selectedCategory)

  const featuredProjects = projects.filter(project => project.featured)

  return (
    <div className={style.mainPortfolio}>

      {/* Hero Section */}
      <div className={style.heroSection}>
        <div className={style.containerHead}>
          <h1>Notre Portfolio</h1>
          <p className={style.subtitle}>
            Des projets d'envergure, des résultats concrets
          </p>
          <p className={style.description}>
            Découvrez nos réalisations dans les domaines de l'immobilier, de l'agropastoral,
            de la finance et du développement industriel. Chaque projet témoigne de notre
            expertise et de notre engagement envers l'excellence.
          </p>
        </div>
      </div>

      {/* Stats Section */}
      <div className={style.statsSection}>
        <div className={style.sectionContainer}>
          <div className={style.statsGrid}>
            {stats.map((stat, index) => (
              <div key={index} className={style.statCard}>
                <div className={style.statNumber}>{stat.number}</div>
                <div className={style.statLabel}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Featured Projects */}
      {featuredProjects.length > 0 && (
        <div className={style.featuredSection}>
          <div className={style.sectionContainer}>
            <h2 className={style.sectionTitle}>Projets Phares</h2>
            <div className={style.featuredGrid}>
              {featuredProjects.map((project) => (
                <div 
                  key={project.id} 
                  className={style.featuredCard}
                  onClick={() => setSelectedProject(project)}
                >
                  <div className={style.projectImage}>{project.image}</div>
                  <div className={style.projectContent}>
                    <div className={style.projectMeta}>
                      <span className={style.category}>{project.category}</span>
                      <span className={style.year}>{project.year}</span>
                    </div>
                    <h3>{project.title}</h3>
                    <p className={style.client}>Client : {project.client}</p>
                    <p className={style.description}>{project.description}</p>
                    <button className={style.detailsBtn}>Voir les détails →</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Category Filter */}
      <div className={style.filterSection}>
        <div className={style.sectionContainer}>
          <h2 className={style.sectionTitle}>Tous Nos Projets</h2>
          <div className={style.categoryFilter}>
            {categories.map((category) => (
              <button
                key={category}
                className={`${style.categoryBtn} ${selectedCategory === category ? style.active : ''}`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* All Projects */}
      <div className={style.projectsSection}>
        <div className={style.sectionContainer}>
          <div className={style.projectsGrid}>
            {filteredProjects.map((project) => (
              <div 
                key={project.id} 
                className={style.projectCard}
                onClick={() => setSelectedProject(project)}
              >
                <div className={style.projectIcon}>{project.image}</div>
                <div className={style.projectMeta}>
                  <span className={style.category}>{project.category}</span>
                  <span className={style.duration}>⏱ {project.duration}</span>
                </div>
                <h3>{project.title}</h3>
                <p className={style.client}>📋 {project.client}</p>
                <p>{project.description}</p>
                <button className={style.viewBtn}>En savoir plus</button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Partnership Program */}
      <div className={style.partnershipSection}>
        <div className={style.partnershipContainer}>
          <div className={style.partnershipIcon}>🤝</div>
          <h2>COLLABOREZ AVEC NOUS</h2>
          <p className={style.partnershipIntro}>
            Vous entretenez des relations privilégiées avec des décisionnaires ?
            Collaborez avec nous et bénéficiez d'une rémunération attractive !
          </p>
          
          <div className={style.partnershipContent}>
            <div className={style.partnershipBenefits}>
              <h3>Profils Recherchés</h3>
              <ul>
                <li>✓ Directeurs généraux</li>
                <li>✓ Directeurs généraux adjoints</li>
                <li>✓ Directeurs Administratifs et Financiers</li>
                <li>✓ Directeurs Comptables et DRH</li>
                <li>✓ Directeurs des Achats</li>
                <li>✓ Décisionnaires stratégiques</li>
              </ul>
            </div>
            
            <div className={style.partnershipBenefits}>
              <h3>Vos Avantages</h3>
              <ul>
                <li>💰 Commission attractive sur chaque mission</li>
                <li>🎯 Accompagnement personnalisé</li>
                <li>📊 Transparence totale sur les projets</li>
                <li>🤝 Relation de confiance long terme</li>
                <li>🏆 Reconnaissance de votre apport</li>
              </ul>
            </div>
          </div>

          <div className={style.partnershipCta}>
            <p>Intéressé par cette opportunité de collaboration ?</p>
            <div className={style.contactButtons}>
              <a href="mailto:info@getcongo.com" className={style.primaryBtn}>
                📧 info@getcongo.com
              </a>
              <a href="mailto:contact@get-conseil.com" className={style.secondaryBtn}>
                ✉️ Nous contacter
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Project Modal */}
      {selectedProject && (
        <div className={style.modalOverlay} onClick={() => setSelectedProject(null)}>
          <div className={style.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={style.closeBtn} onClick={() => setSelectedProject(null)}>✕</button>
            
            <div className={style.modalHeader}>
              <div className={style.modalIcon}>{selectedProject.image}</div>
              <div>
                <h2>{selectedProject.title}</h2>
                <p className={style.modalMeta}>
                  <span>{selectedProject.category}</span> • 
                  <span>{selectedProject.year}</span> • 
                  <span>{selectedProject.duration}</span>
                </p>
              </div>
            </div>

            <div className={style.modalBody}>
              <div className={style.modalSection}>
                <h3>Client</h3>
                <p>{selectedProject.client}</p>
              </div>

              <div className={style.modalSection}>
                <h3>Description Complète</h3>
                <p>{selectedProject.fullDescription}</p>
              </div>

              <div className={style.modalSection}>
                <h3>Services Fournis</h3>
                <ul className={style.servicesList}>
                  {selectedProject.services.map((service, index) => (
                    <li key={index}>✓ {service}</li>
                  ))}
                </ul>
              </div>

              <div className={style.modalSection}>
                <h3>Résultats Obtenus</h3>
                <ul className={style.resultsList}>
                  {selectedProject.results.map((result, index) => (
                    <li key={index}>🎯 {result}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default PortfolioPage